import React, { Suspense, lazy } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from "react-router-dom";
import Home from "./views/Home/Home";
import Collection from "./views/collection/Collection";
import About from "./views/about/About";
import USP from "./views/usp/USP";
import StoreLocator from "./views/StoreLocator/StoreLocator";
import Honey from "./views/honey/Honey";
import Services from "./views/Services/Services";
import MainService from "./common/MainService";
import { useEffect } from "react";
import ProcessingUnitLocator from "./views/ProcessingUnitLocator/ProcessingUnitLocator";
import Farmer from "./views/Farmers/Farmer";
import EcoContributor from "./views/EcoContributor/EcoContributor";
import EcoEntrepreneur from "./views/EcoEntrepreneur/EcoEntrepreneur";
import LandingPage from "./views/LandingPage/LandingPage";import Consumers from "./views/Consumers/Consumers";
import Brands from "./views/Brands/Brands";
import Beekeepers from "./views/Beekeepers/Beekeepers";
import OurTechnology from "./views/OurTechnology/OurTechnology";
import FarmLocation from "./views/FarmLocation/FarmLocation";
import DataCenter from "./views/DataCenter/DataCenter";
import OurTechnologyMain from "./views/OurTechnology/OurTechnologyMain";
import ComingSoon from "./views/ComingSoon/ComingSoon";
import EdgeStack from "./views/EdgeStack/EdgeStack";
import BookDemo from "./views/BookDemo/BookDemo";
import { EcoBee } from "./views/ecoBee/EcoBee";

const TermsCondition = lazy(() => import("./views/termscondition/TermsCondition"));
const PrivacyPolicy = lazy(() => import("./views/privacyPolicy/PrivacyPolicy"));
const OurProducts = lazy(() => import("./views/OurProducts/OurProducts"));

function App() {
  useEffect(() => {
    accessToken();
  }, []);

  const accessToken = () => {
    MainService.getAccess()
      .then((res) => {
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <>
      <Suspense fallback={<div className="spinner">Loading...</div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/manufacturers" element={<Home />} />
          <Route path="/collections" element={<Collection />}>
            <Route path="products/:subId" element={<Honey />} />
          </Route>
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route path="cookie-privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/our-usp" element={<USP />} />
          <Route path="/services" element={<Services />} />
          <Route path="/location" element={<StoreLocator />} />
          <Route path="/processing-location" element={<ProcessingUnitLocator />} />
          <Route path="/farmers" element={<Farmer />} />
          <Route path="/eco-contributor" element={<EcoContributor />} />
          <Route path="/eco-entrpreneur" element={<EcoEntrepreneur />} />
          <Route path="/consumers" element={<Consumers />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/beekeepers" element={<Beekeepers />} />
          <Route path="/products" element={<OurProducts />} />
          <Route path="/technology" element={<OurTechnologyMain />} />
          <Route path="/app" element={<OurTechnology />} />
          <Route path="/farm-location" element={<FarmLocation />} />
          <Route path="/data-center-location" element={<DataCenter />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/edge-ai-stack" element={<EdgeStack />} />
          <Route path="/eco-bee" element={<EcoBee />} />
          <Route path="/book-demo" element={<BookDemo/>}/>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;

